import styles from './ChartWrapper.module.scss';
import PropTypes from 'prop-types';

const ChartWrapper = (props) => {
    const {
        id,
        comboClass,
        children,
        width = '33%',
        height = '440px',
        style
    } = props;
    return (
        <div
            id={id}
            className={
                comboClass
                    ? `${styles.wrapper} ${props.comboClass}`
                    : styles.wrapper
            }
            style={
                style
                    ? { ...style, width: width, height: height }
                    : { width: width, height: height }
            }
        >
            {children}
        </div>
    );
};

ChartWrapper.propTypes = {
    id: PropTypes.string,
    comboClass: PropTypes.string,
    children: PropTypes.any,
    width: PropTypes.string,
    height: PropTypes.string,
    style: PropTypes.object
};
export default ChartWrapper;
